import { GcpBox, GcpDateRangeRecurring, GcpTypography } from '@back-office/ui';
import { Button, Dialog, Divider, IconButton } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import { DateRange } from '@material-ui/pickers';
import { observer } from 'mobx-react';
import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: theme.palette.common.mineShaft,
  },
  dialog: {
    width: '400px',
    margin: 'auto',
  },
}));

export interface Store {
  date: DateRange<Date>;
  openCalendar: boolean;
  query: string;
  handleOnChangeDatePicker: (date: DateRange<Date>) => void;
  handleOnClickDatePicker: () => void;
  handleOnCloseDatePicker: () => void;
  handleOnClear: (event: MouseEvent<HTMLOrSVGElement>) => void;
  handleOnExport: () => void;
  handleClose: (event: MouseEvent<HTMLOrSVGElement>, reason: string) => void;
}

interface ExportTransactionsModalProps {
  open: boolean;
  handleOnClose: () => void;
}

const ExportTransactionsModal: FC<ExportTransactionsModalProps> = observer(
  (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { open, handleOnClose } = props;
    const { state } = useViewModel(handleOnClose);

    return (
      <Dialog
        fullWidth
        aria-labelledby="export-transactions-dialog"
        className={classes.dialog}
        open={open}
        onClose={state.handleClose}
      >
        <GcpBox
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          ml={3}
        >
          <GcpTypography style={{ fontSize: '16px' }} variant="h3">
            {t('payment_file.transactions_list.modal.title')}
          </GcpTypography>
          <IconButton aria-label="Close" onClick={state.handleOnClear}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        </GcpBox>
        <Divider />
        <GcpBox mb={3} ml={3} mr={3} mt={3}>
          <GcpBox>
            <GcpTypography
              paint="mineShaft"
              size={14}
              variant="body1"
              weight={500}
            >
              {t('payment_file.transactions_list.modal.instruction')}
            </GcpTypography>
          </GcpBox>
          <GcpBox mt={1}>
            <GcpDateRangeRecurring
              fullWidth
              date={state.date}
              handleOnChange={state.handleOnChangeDatePicker}
              handleOnClear={state.handleOnClear}
              handleOnClick={state.handleOnClickDatePicker}
              handleOnClose={state.handleOnCloseDatePicker}
              openCalendar={state.openCalendar}
            />
          </GcpBox>
        </GcpBox>
        <Divider />
        <GcpBox
          display="flex"
          justifyContent="flex-end"
          mb={1}
          ml={3}
          mr={3}
          mt={1}
        >
          <Button
            color="primary"
            disabled={!state.date[0] || !state.date[1]}
            size="large"
            type="button"
            variant="contained"
            onClick={state.handleOnExport}
          >
            {t('payment_file.transactions_list.modal.export')}
          </Button>
        </GcpBox>
      </Dialog>
    );
  }
);

export default ExportTransactionsModal;
